const Config = {
  appid: 'xxxx',
  crypto: {
    iv: 'rS2dS3zO2dD5hN1p',
    key: 'zH5gB8gM5gU2rC6h',
  },
  cookie: {
    expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 5), // new Date(Date.now() + 10000); 10s
  },

  basename: '/website-html',// 二级目录配置

  // 目前目前 monitor 没有定义成 data-monitor 需自行添加
  monitor: {
    url: '/api/analysis/monitor',
    name: 'xxxx',
    user_name: '',
  }
};

export default Config;
